import React from 'react';

export type Viewport = { width: number; height: number };

/**
 * Returns the current viewport size.
 */
export function useViewport(): Viewport {
    const [size, setSize] = React.useState<Viewport>({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    React.useEffect(() => {
        let req: number;
        function handleResize() {
            req = window.requestAnimationFrame(() => {
                setSize({ width: window.innerWidth, height: window.innerHeight });
            });
        }

        // Add the listener, then setWidth to avoid race.
        window.addEventListener('resize', handleResize, { passive: true });
        setSize({ width: window.innerWidth, height: window.innerHeight });

        return () => {
            window.removeEventListener('resize', handleResize);
            if (req) {
                window.cancelAnimationFrame(req);
            }
        };
    }, []);

    return size;
}
